module.exports = "<section class=\"gw-vehicle-collision\">\r\n    <h2 class=\"gw-page-section-title\">{{'fnol.pa.directives.vehicle-collision.What was the initial point of impact?'|translate}}</h2>\r\n\r\n    <div class=\"gw-car\">\r\n        <div gw-fnol-pa-vehicle-damage-picker damaged-part=\"selectedPart\"></div>\r\n    </div>\r\n    <div class=\"gw-damage-info\" gw-fnol-pa-damage-list></div>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/fnol/pa/directives/templates/vehicle-collision.html
// module id = 668
// module chunks = 0